import { render } from "./HeroiconsSolidArrowsExpand.vue?vue&type=template&id=7458b5c2"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowsExpand.vue"]])

export default __exports__